import { Formik } from "formik";
import * as Yup from "yup";
import React from "react";
import CustomInput from "../CustomInput";
import TextArea from "../widgets/TextArea";
import { Button } from "../ui/button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createInvoiceGroup, updateInvoiceGroup } from "src/api/invoice";
import { cn, getCustomizationValue, showSuccessToast } from "src/lib/utils";
import { usePortalContext } from "src/context/PortalContext";
import { DialogClose } from "../ui/dialog";
import { useAuth } from "src/providers/AuthProvider";

const validationSchema = Yup.object().shape({
	name: Yup.string().required(),
	description: Yup.string(),
});

const CreateInvoiceGroup = ({ invoiceGroup }) => {
	const { user } = useAuth();
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();

	const initialValues = {
		uuid: invoiceGroup?.uuid,
		name: invoiceGroup?.name ?? "",
		description: invoiceGroup?.description ?? "",
	};

	const { mutate, isLoading } = useMutation(invoiceGroup ? updateInvoiceGroup : createInvoiceGroup, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			queryClient.invalidateQueries(["invoice-groups"]);
			closePortal();
		},
	});

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ values, handleChange, handleSubmit }) => (
				<form onSubmit={handleSubmit} className="tw-flex tw-flex-col tw-flex-1 tw-gap-4">
					<CustomInput
						name="name"
						value={values.name}
						onChange={handleChange}
						label={cn(getCustomizationValue(user, "invoice_group_label", true), " Name")}
						placeholder={cn(getCustomizationValue(user, "invoice_group_label", true), " Name")}
					/>
					<TextArea
						label="Description"
						name="description"
						placeholder="Description"
						value={values.description}
						onChange={handleChange}
						className="!tw-mb-auto"
					/>

					<div className="tw-flex tw-items-center tw-justify-end tw-gap-4">
						<DialogClose asChild>
							<Button type="button" variant="ghost">
								Cancel
							</Button>
						</DialogClose>
						<Button disabled={isLoading}>Save</Button>
					</div>
				</form>
			)}
		</Formik>
	);
};

export default CreateInvoiceGroup;
